Ext.define('SA.TableBodySection', {
    extend: 'SA.TableSection',

    getScrollRect() {
        return this.scroller.getRect();
    },

    setData(data) {
        data.forEach((rowData, rowIndex) => {
            rowData.forEach((cellData, columnIndex) => {
                var el = this.table.getCellAt({rowIndex, columnIndex});

                this.cellsCache.setState(el, cellData);
            });
        });
    },

    setScrollerSizeForContainerSize({containerSize}) {
        this.scroller.setSize(containerSize);
    }
});